import { createSlice, createAsyncThunk, current } from "@reduxjs/toolkit";
import { produtosApi } from "../page/OrderResumePag/_services/api";
import { getCategory } from "../components/BurgerMenuContents/MenuContainer/Categories/services/categoriesServices";
import { trackMarketplaceSearchResults } from "../utils/gtm";
import { getWhitelabelFromMemory } from "../lib/sharedSessionMemory";

const orderAlphabetical = (a, b) => {
  const first = a?.label.toLowerCase() || "";
  const second = b?.label.toLowerCase() || "";
  if (first < second) return -1;
  if (first > second) return 1;
  return 0;
};

function buildRangeParams(minValue, maxValue) {
  const paymentMode = getWhitelabelFromMemory()?.config?.payment_mode;
  if (paymentMode === "money") {
    return { price_min_suggested: minValue, price_max_suggested: maxValue };
  }
  return { points_min_suggested: minValue, points_max_suggested: maxValue };
}

export const fetchCategory = createAsyncThunk(
  "/fetchCategory",
  async ({ id, newPage, limit, cpf, desc, screenName }, { getState }) => {
    const state = getState();
    const uuidsCheckBrands = UuidsCheckBrands(state);
    const order = selectOrder(state);

    const rangeSlide = {
      currentMinPoints: state.filterSlice.currentMinSlide || selectLowerValuePoints(state),
      currentMaxPoints: selectCurrentSlideValue(state),
      lowerValue: selectLowerValue(state),
      greaterValue: selectGreaterValue(state),
      greaterValuePoints: selectGreaterValuePoints(state),
      lowerValuePoints: selectLowerValuePoints(state),
    };

    // Buscar a categoria para obter o array categories_uuid
    const categoryData = await getCategory(id);
    const categoriesUuid = categoryData?.categories_uuid || [id];

    const params = {
      page: newPage + 1,
      per_page: limit,
      partner_customer_id: cpf,
      sort: order || "relevant",
      ...buildRangeParams(rangeSlide?.currentMinPoints, rangeSlide?.currentMaxPoints),
      categories: categoriesUuid,
      ...(uuidsCheckBrands.length > 0 && {
        brands: uuidsCheckBrands.split(","),
      }),
      exact: false,
    };

    const response = await produtosApi.get("/v1/products/search", {
      params,
    });

    setTagParameters('categoria', response.data?.total ?? 0, desc, screenName)

    return response.data;
  },
);

export const fetchBrands = createAsyncThunk(
  "/fetchBrands",

  async ({ id, newPage, limit, cpf, desc, brandIds, screenName }, { getState }) => {

    const state = getState();
    const uuidsCheckCategories = UuidsCheckCategories(state);
    const order = selectOrder(state);
    const rangeSlide = {
      currentMinPoints: state.filterSlice.currentMinSlide || selectLowerValuePoints(state),
      currentMaxPoints: selectCurrentSlideValue(state),
      lowerValue: selectLowerValue(state),
      greaterValue: selectGreaterValue(state),
      greaterValuePoints: selectGreaterValuePoints(state),
      lowerValuePoints: selectLowerValuePoints(state),
    };

    const params = {
      page: newPage + 1,
      per_page: limit,
      partner_customer_id: cpf,
      sort: order || "relevant",
      ...buildRangeParams(rangeSlide?.currentMinPoints, rangeSlide?.currentMaxPoints),
      brands: brandIds.length > 0 ? brandIds : [id],
      ...(uuidsCheckCategories.length > 0 && {
        categories: uuidsCheckCategories.split(","),
      }),
      exact: false,
    };

    const response = await produtosApi.get("/v1/products/search", {
      params: params,
    });

    setTagParameters('marca', response.data?.total ?? 0, desc, screenName)

    return response.data;
  },
);

export const fetchProducts = createAsyncThunk(
  "/fetchProducts",
  async ({ newPage, limit, cpf, desc, screenName }, { getState }) => {
    const state = getState();
    const uuidsCheckCategories = UuidsCheckCategories(state);
    const uuidsCheckBrands = UuidsCheckBrands(state);
    const order = selectOrder(state);
    const rangeSlide = {
      currentMinPoints: state.filterSlice.currentMinSlide || selectLowerValuePoints(state),
      currentMaxPoints: selectCurrentSlideValue(state),
      lowerValue: selectLowerValue(state),
      greaterValue: selectGreaterValue(state),
      greaterValuePoints: selectGreaterValuePoints(state),
      lowerValuePoints: selectLowerValuePoints(state),
    };

    const params = {
      
      page: newPage + 1,
      per_page: limit,
      q: desc,
      partner_customer_id: cpf,
      sort: order || "relevant",
      ...buildRangeParams(rangeSlide?.currentMinPoints, rangeSlide?.currentMaxPoints),
      ...(uuidsCheckCategories.length > 0 && {
        categories: uuidsCheckCategories.split(","),
      }),
      ...(uuidsCheckBrands.length > 0 && {
        brands: uuidsCheckBrands.split(","),
      }),
      exact: 0,
    };

    const response = await produtosApi.get("/v1/products/search", {
      params: params,
    });

    const total = response.data?.total ?? 0;
    if (total > 0) {
      setTagParameters("produto", total, desc, screenName);
    }

    return response.data;
  },
);

function setTagParameters(type, total, term, screenName) {
  trackMarketplaceSearchResults({
    status: total > 0 ? "sucesso" : `${type}-nao-encontrado`,
    searchTerm: term,
    contentType: "busca",
    screenName,
  });
}

function MountCategories(Categories, state) {
  const categoriesArray = [];
  const seenCategories = new Set();

  for (let i in Categories) {
    const product = Categories[i];

    // Processar product_categories array do novo formato
    if (
      product.product_categories &&
      Array.isArray(product.product_categories)
    ) {
      product.product_categories.forEach((category) => {
        if (!seenCategories.has(category.category_uuid)) {
          seenCategories.add(category.category_uuid);

          const Exists = current(state).filter(
            (element) => element.id === category.category_uuid,
          );

          if (Exists.length === 0) {
            const categoryJson = {};
            categoryJson.label = category.category_name;
            categoryJson.id = category.category_uuid;
            categoryJson.check = false;
            categoriesArray[categoryJson.id] = categoryJson;
          }
        }
      });
    }

    if (
      product.categories &&
      product.categories[0] &&
      !seenCategories.has(product.categories[0].id)
    ) {
      seenCategories.add(product.categories[0].id);

      const Exists = current(state).filter(
        (element) => element.id == product.categories[0].id,
      );

      if (Exists.length === 0) {
        const categoryJson = {};
        categoryJson.label = product.categories[0].label;
        categoryJson.id = product.categories[0].id;
        categoryJson.check = false;
        categoriesArray[categoryJson.id] = categoryJson;
      }
    }
  }

  const values = Object.values(categoriesArray).sort(orderAlphabetical);

  return values;
}

function MountBrands(Brands, state) {
  const brandsArray = [];
  const seenBrands = new Set();

  for (let i in Brands) {
    const product = Brands[i];

    if (
      product.brand_uuid &&
      product.brand_name &&
      !seenBrands.has(product.brand_uuid)
    ) {
      seenBrands.add(product.brand_uuid);

      const Exists = current(state).filter(
        (element) => element.id === product.brand_uuid,
      );

      if (Exists.length === 0) {
        const brandJson = {};
        brandJson.label = product.brand_name;
        brandJson.id = product.brand_uuid;
        brandJson.check = false;
        brandsArray[brandJson.id] = brandJson;
      }
    }

    if (
      product.brand &&
      product.brand.id &&
      !seenBrands.has(product.brand.id)
    ) {
      seenBrands.add(product.brand.id);

      const Exists = current(state).filter(
        (element) => element.id == product.brand.id,
      );

      if (Exists.length === 0) {
        const brandJson = {};
        brandJson.label = product.brand.label;
        brandJson.id = product.brand.id;
        brandJson.check = false;
        brandsArray[brandJson.id] = brandJson;
      }
    }
  }

  const values = Object.values(brandsArray).sort(orderAlphabetical);
  return values;
}

const initialState = {
  brands: [],
  categories: [],
  order: "",
  lowerValue: "",
  greaterValue: "",
  greaterValuePoints: "",
  lowerValuePoints: "",
  initialLowerValue: "",
  initialGreaterValue: "",
  initialLowerValuePoints: "",
  initialGreaterValuePoints: "",
  rangeSlide: "",
  minRangeSlide: "",
  factor: 1,
  initialFactor: "",
  currentSlide: "",
  currentMinSlide: "",
};

const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    addBrand: (state, action) => {
      state.brands = action.payload;
    },
    delBrand: (state, action) => {
      var arr = state.brands.filter((item) => {
        return item.id == action.payload.id;
      });
      state.brands = arr;
    },
    toggleCheckBrand: (state, action) => {
      const index = state.brands.findIndex(
        (todo) => todo.id === action.payload.id,
      );
      state.brands[index].check = !state.brands[index].check;
    },
    toggleCheckCategory: (state, action) => {
      const index = state.categories.findIndex(
        (todo) => todo.id === action.payload.id,
      );
      state.categories[index].check = !state.categories[index].check;
    },
    clearCheckBrand: (state, action) => {
      state.brands.map((item) => {
        item.check = false;
      });
      state.order = "";
    },
    clearCheckCategories: (state, action) => {
      state.categories.map((item) => {
        item.check = false;
      });
      state.order = "";
    },
    setOrder: (state, action) => {
      state.order = action.payload.order;
    },
    setCurrentLocation: (state, action) => {
      state.currentLocation = action.payload.location;
    },
    setRangeSlide: (state, action) => {
      state.rangeSlide = action.payload.value;
    },
    setCurrentSlide: (state, action) => {
      state.currentSlide = action.payload.value;
    },
    setMinRangeSlide: (state, action) => {
      state.minRangeSlide = action.payload.value;
    },
    setCurrentMinSlide: (state, action) => {
      state.currentMinSlide = action.payload.value;
    },
    setBrandsCategory: (state, action) => {
      state.categories = MountCategories(action.payload, state.categories);
      state.brands = MountBrands(action.payload, state.brands);
    },
    setBorderPrices: (state, action) => {
      state.greaterValue = action.payload.greaterValue;
      state.lowerValue = action.payload.lowerValue;
    },
    resetFilters: () => initialState,
  },
  extraReducers: (builder) => {
    (builder.addCase(fetchCategory.fulfilled, (state, action) => {
      state.categories =
        state.categories.length === 0
          ? MountCategories(action.payload.data, state.categories)
          : state.categories;
      state.brands =
        state.brands.length === 0
          ? MountBrands(action.payload.data, state.brands)
          : state.brands;

      const {
        price_max,
        price_min,
        points_max,
        points_min,
        points_min_suggested,
      } = action.payload;
      const points_min_with_suggested =
        points_min_suggested > 0 ? points_min_suggested : points_min;

      if (
        price_max !== undefined &&
        price_min !== undefined &&
        price_max > 0 &&
        price_min > 0
      ) {
        state.greaterValue = price_max;
        state.lowerValue = price_min;
        if (
          state.initialGreaterValue === "" ||
          state.initialLowerValue === ""
        ) {
          state.initialGreaterValue = price_max;
          state.initialLowerValue = price_min;
        }
      }

      if (
        points_max !== undefined &&
        points_min_with_suggested !== undefined &&
        points_max > 0 &&
        points_min_with_suggested > 0
      ) {
        state.greaterValuePoints = points_max;
        state.lowerValuePoints = points_min_with_suggested;
        if (
          state.initialGreaterValuePoints === "" ||
          state.initialLowerValuePoints === ""
        ) {
          state.initialGreaterValuePoints = points_max;
          state.initialLowerValuePoints = points_min_with_suggested;
        }
      }

      if (action.payload.price_max && action.payload.points_max) {
        const newFactor = action.payload.points_max / action.payload.price_max;
        state.factor = newFactor;
        if (state.initialFactor === "") {
          state.initialFactor = newFactor;
        }
      }
    }),
      builder.addCase(fetchBrands.fulfilled, (state, action) => {
        state.categories =
          state.categories.length === 0
            ? MountCategories(action.payload.data, state.categories)
            : state.categories;
        state.brands =
          state.brands.length === 0
            ? MountBrands(action.payload.data, state.brands)
            : state.brands;

        const {
          price_max,
          price_min,
          points_max,
          points_min,
          points_min_suggested,
        } = action.payload;
        const points_min_with_suggested =
          points_min_suggested > 0 ? points_min_suggested : points_min;

        if (
          price_max !== undefined &&
          price_min !== undefined &&
          price_max > 0 &&
          price_min > 0
        ) {
          state.greaterValue = price_max;
          state.lowerValue = price_min;
          if (
            state.initialGreaterValue === "" ||
            state.initialLowerValue === ""
          ) {
            state.initialGreaterValue = price_max;
            state.initialLowerValue = price_min;
          }
        }

        if (
          points_max !== undefined &&
          points_min_with_suggested !== undefined &&
          points_max > 0 &&
          points_min_with_suggested > 0
        ) {
          state.greaterValuePoints = points_max;
          state.lowerValuePoints = points_min_with_suggested;
          if (
            state.initialGreaterValuePoints === "" ||
            state.initialLowerValuePoints === ""
          ) {
            state.initialGreaterValuePoints = points_max;
            state.initialLowerValuePoints = points_min_with_suggested;
          }
        }

        if (action.payload.price_max && action.payload.points_max) {
          const newFactor =
            action.payload.points_max / action.payload.price_max;
          state.factor = newFactor;
          if (state.initialFactor === "") {
            state.initialFactor = newFactor;
          }
        }
      }),
      builder.addCase(fetchProducts.fulfilled, (state, action) => {
        state.categories =
          state.categories.length === 0
            ? MountCategories(action.payload.data, state.categories)
            : state.categories;
        state.brands =
          state.brands.length === 0
            ? MountBrands(action.payload.data, state.brands)
            : state.brands;
        const {
          price_max,
          price_min,
          points_max,
          points_min,
          points_min_suggested,
        } = action.payload;
        const points_min_with_suggested =
          points_min_suggested > 0 ? points_min_suggested : points_min;

        if (
          price_max !== undefined &&
          price_min !== undefined &&
          price_max > 0 &&
          price_min > 0
        ) {
          state.greaterValue = price_max;
          state.lowerValue = price_min;
          // Salva os valores iniciais apenas na primeira consulta (quando estão vazios)
          if (
            state.initialGreaterValue === "" ||
            state.initialLowerValue === ""
          ) {
            state.initialGreaterValue = price_max;
            state.initialLowerValue = price_min;
          }
        }

        if (
          points_max !== undefined &&
          points_min_with_suggested !== undefined &&
          points_max > 0 &&
          points_min_with_suggested > 0
        ) {
          state.greaterValuePoints = points_max;
          state.lowerValuePoints = points_min_with_suggested;
          if (
            state.initialGreaterValuePoints === "" ||
            state.initialLowerValuePoints === ""
          ) {
            state.initialGreaterValuePoints = points_max;
            state.initialLowerValuePoints = points_min_with_suggested;
          }
        }

        if (action.payload.price_max && action.payload.points_max) {
          const newFactor =
            action.payload.points_max / action.payload.price_max;
          state.factor = newFactor;
          if (state.initialFactor === "") {
            state.initialFactor = newFactor;
          }
        }
      }));
  },
});

export const {
  addBrand,
  delBrand,
  toggleCheckBrand,
  toggleCheckCategory,
  setOrder,
  clearCheckBrand,
  clearCheckCategories,
  setRangeSlide,
  setBrandsCategory,
  setBorderPrices,
  resetFilters,
  setCurrentSlide,
  setMinRangeSlide,
  setCurrentMinSlide,
} = filterSlice.actions;

export const selectBrands = (state) => state.filterSlice.brands;
export const selectCategories = (state) => state.filterSlice.categories;
export const selectOrder = (state) => state.filterSlice.order;
export const selectLowerValue = (state) => state.filterSlice.lowerValue;
export const selectGreaterValue = (state) => state.filterSlice.greaterValue;
export const selectGreaterValuePoints = (state) =>
  state.filterSlice.greaterValuePoints;
export const selectLowerValuePoints = (state) =>
  state.filterSlice.lowerValuePoints;

export const selectInitialLowerValue = (state) =>
  state.filterSlice.initialLowerValue;
export const selectInitialGreaterValue = (state) =>
  state.filterSlice.initialGreaterValue;
export const selectInitialLowerValuePoints = (state) =>
  state.filterSlice.initialLowerValuePoints;
export const selectInitialGreaterValuePoints = (state) =>
  state.filterSlice.initialGreaterValuePoints;

export const factor = (state) => state.filterSlice.factor;
export const selectInitialFactor = (state) => state.filterSlice.initialFactor;
export const selectRangeSlide = (state) => state.filterSlice.rangeSlide;
export const selectCurrentSlideValue = (state) =>
  state.filterSlice.currentSlide;
export const counterCheckBrands = (state) =>
  state.filterSlice.brands.filter((item) => item.check === true).length;
export const counterCheckCategories = (state) =>
  state.filterSlice.categories.filter((item) => item.check === true).length;
export const UuidsCheckBrands = (state) =>
  state.filterSlice.brands
    .filter((item) => item.check === true)
    .map((it) => it.id)
    .toString();
export const UuidsCheckCategories = (state) =>
  state.filterSlice.categories
    .filter((item) => item.check === true)
    .map((it) => it.id)
    .toString();

export default filterSlice.reducer;
